import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import * as React from 'react';

const styles = require('./Scrollable.less');
const cx = classnames.bind(styles);

export enum ScrollBehavior
{
    None = 'None',
    OnHover = 'OnHover',
    OnSelect = 'OnSelect',
    Always = 'Always'
}

export enum ScrollAppearance
{
    ForWhiteContent = 'WhiteContent',
    ForLightBlueContent = 'LightBlueContent'
}

export interface ScrollableProps
{
    isScrollX:boolean,
    isScrollY:boolean,
    behavior:ScrollBehavior;
    className?:string;
    containerClassName?:string;
    appearance?:ScrollAppearance;
    selectedItemId?:string;
    isAutoScrollToBottom?:boolean;
    onRef?:(ref:HTMLElement | null) => void
    id?:string;
}

export class Scrollable extends React.Component<ScrollableProps, any>
{
    private _scrollHolder:HTMLElement = null;

    constructor(props:any)
    {
        super(props);
    }

    private _isEnabled(behavior:ScrollBehavior):boolean
    {
        return behavior === ScrollBehavior.OnHover || behavior === ScrollBehavior.OnSelect || behavior === ScrollBehavior.Always;
    }

    @bind
    private _onScrollHolderRef(ref:HTMLElement)
    {
        this._scrollHolder = ref;

        const {onRef} = this.props;

        onRef && onRef(ref);
    }

    @bind
    private _scrollToItem()
    {
        setTimeout(() =>
        {
            const {selectedItemId} = this.props;
            const item:HTMLElement = document.getElementById(selectedItemId);

            if( this._scrollHolder && item )
            {
                const holderRect:ClientRect = this._scrollHolder.getBoundingClientRect();
                const itemRect:ClientRect = item.getBoundingClientRect();

                const itemTop:number = itemRect.top - holderRect.top + this._scrollHolder.scrollTop;
                const itemBottom:number = itemRect.bottom - holderRect.top + this._scrollHolder.scrollTop;

                if( itemTop >= this._scrollHolder.scrollTop + holderRect.height
                    || itemBottom >= this._scrollHolder.scrollTop + holderRect.height
                    || itemTop < this._scrollHolder.scrollTop )
                // this._scrollHolder.scrollTop = itemTop;
                    this._scrollHolder.scrollTo({top: itemTop, behavior: 'smooth'});
            }
        });
    }

    @bind
    private _scrollToBottom()
    {
        if( this._scrollHolder )
            this._scrollHolder.scrollTop = this._scrollHolder.scrollHeight;
        // this._scrollHolder.scroll({ left:0, top:this._scrollHolder.scrollHeight, behavior:'smooth'});
    }

    componentDidMount()
    {
        const {selectedItemId, isAutoScrollToBottom} = this.props;

        if( isAutoScrollToBottom )
            this._scrollToBottom();
        else if( selectedItemId != null )
            this._scrollToItem();
    }

    componentDidUpdate()
    {
        const {selectedItemId, isAutoScrollToBottom} = this.props;

        if( isAutoScrollToBottom )
            this._scrollToBottom();
        else if( selectedItemId != null )
            this._scrollToItem();
    }

    @bind
    render()
    {
        const {className, behavior, isScrollX, isScrollY, containerClassName, id} = this.props;
        const isScrollEnabled = this._isEnabled(behavior);
        const isOnHover = behavior === ScrollBehavior.OnHover;
        const isAlways = behavior === ScrollBehavior.Always;

        let appearance = this.props.appearance;
        if( !appearance )
            appearance = ScrollAppearance.ForWhiteContent;

        const forWhiteContent = appearance === ScrollAppearance.ForWhiteContent;
        const forLightBlueContent = appearance === ScrollAppearance.ForLightBlueContent;

        let overflowStyle:any = {};
        if( isScrollEnabled )
        {
            overflowStyle.overflowX = isScrollX ? 'auto' : 'hidden';
            overflowStyle.overflowY = isScrollY ? 'auto' : 'hidden';
        }

        // const noPointerEventsStyle =
        //     {
        //         pointerEvents: 'none'
        //     };

        return <div className={cx('scrollableContainer',
            {'scrollableOnHover': isOnHover},
            {'scrollableAlways': isAlways},
            {'forWhiteContent': forWhiteContent},
            {'forLightBlueContent': forLightBlueContent},
            containerClassName
        )}>

            <div
                data-element-scrollable={true}
                className={cx('overflowHolder', className)}
                style={overflowStyle}
                ref={this._onScrollHolderRef}
                id={id}
            >
                {this.props.children}
            </div>

            {/* TODO: do not use these until we get a different scroll impl in place */}
            {/*{isScrollY && <div style={noPointerEventsStyle} className={cx('baseScrollbarFadeIn', 'scrollBarFadeInRight')}/>}*/}
            {/*{isScrollX && <div style={noPointerEventsStyle} className={cx('baseScrollbarFadeIn', 'scrollBarFadeInBottom')}/>}*/}

        </div>;
    }
}
